export function radToDegree(deg: number): number {
  return (deg * 180) / Math.PI;
}
